import {Component, forwardRef, Injector, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {AbstractColumnComponent} from "../../../framework/entity/grid/abstract-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-inventory-stock-size-single-select-column",
    templateUrl: "./inventory-stock-size-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => InventoryStockSizeSingleSelectColumnComponent), multi: true}
    ]
})
export class InventoryStockSizeSingleSelectColumnComponent extends AbstractColumnComponent implements OnChanges {
    @Input() inventoryIdField: string;

    valueField: string;
    measureAmtField: string;
    measureNameField: string;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + "." + "id";
        this.measureAmtField = this.field + ".measureAmt";
        this.measureNameField = this.field + ".measure.name";
    }

    getDescription(dataItem): string {
        const measureAmtValue = EntityData.getField(dataItem, this.measureAmtField);
        const measureNameValue = EntityData.getField(dataItem, this.measureNameField);
        if (measureAmtValue != undefined) {
            return measureAmtValue + " x " + measureNameValue;
        } else {
            return "";
        }
    }
}
